module.exports = __webpack_public_path__ + "media/images/pic/kids-b9badb21be62bbe966c8cb152f1182e0.png";